<header class="shadow">
    <nav class="navbar navbar-expand-lg navbar-light bg-white">
        <div class="container-xl justify-content-start">
            <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
                <i class="material-icons-round icon-lg">menu</i>
            </button>
            <a class="navbar-brand navbar-logo" href="https://patient.labcorp.com/"><img alt="logo" src="assets/images/logo-patient-color.svg"></a>
            <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/home" (click)="isMenuCollapsed = true">Help Center</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://patient.labcorp.com/account/registration/register" (click)="isMenuCollapsed = true">Create an Account</a>
                    </li>
                </ul>
                <form class="form-inline">
                    <a href="https://patient.labcorp.com/auth" class="btn btn-primary ms-2">Sign In</a>
                </form>
            </div>
        </div>
    </nav>
    <div class="p-1 bg-primary"></div>
</header>
